var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['loading', _vm.white ? 'loading-white': '']},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ball-beat"},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])
}]

export { render, staticRenderFns }